export default {
  min: {
    title:
      'Livraison à votre adresse : Montant manquant pour atteindre la commande minimum (Sous-total hors frais de livraison et pourboire)',
    description:
      'Désolé, vous ne pouvez pas encore commander. {{name}} a fixé un montant minimum de commande de {{threshold}} (hors frais de livraison)',
  },
  max: {
    title: 'Valeur maximale de commande pour la livraison atteinte (Total hors frais de livraison)',
    description:
      'Votre commande a atteint la valeur maximale autorisée de {{threshold}} pour la livraison en ligne. Pour les commandes dépassant ce montant, veuillez nous contacter directement afin que nous puissions organiser la livraison. Merci de votre compréhension !',
  },
};
